export default "__VITE_ASSET__88beeb57__"